/*
 * Shadow host: inheritable reset. Téma: --cb-* változók; sötét: .cb-theme--dark (bot téma vagy auto detektálás).
 */
:host {
    display: block;
    text-align: left;
    font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
    font-size: 14px;
    line-height: 1.45;
    font-weight: normal;
    font-style: normal;
    letter-spacing: normal;
    text-transform: none;
    direction: ltr;
}

.cb-widget-root {
    --cb-primary: #4f46e5;
    --cb-radius: 12px;
    --cb-text: #0f172a;
    --cb-text-muted: #64748b;
    --cb-text-secondary: #475569;
    --cb-bg: #fff;
    --cb-surface: #f8fafc;
    --cb-surface-elevated: #fff;
    --cb-border: #e2e8f0;
    --cb-border-input: #cbd5e1;
    --cb-code-bg: #f1f5f9;
    --cb-blockquote-border: #cbd5e1;
    --cb-shadow-bubble: rgba(15, 23, 42, 0.2);
    --cb-shadow-panel: rgba(15, 23, 42, 0.18);
    --cb-error: #b91c1c;
    --cb-bubble-avatar-bg: #fff;
    --cb-on-primary: #fff;
    --cb-header-btn-hover: rgba(255, 255, 255, 0.16);
    --cb-header-btn-hover-active: rgba(255, 255, 255, 0.24);
    --cb-header-btn-new-bg: rgba(255, 255, 255, 0.14);
    --cb-header-btn-new-hover: rgba(255, 255, 255, 0.24);
    --cb-feedback-bg: #f8fafc;
    --cb-feedback-hover-bg: #fff;
    --cb-feedback-active-mix: #fff;
    color-scheme: light;
    font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
    font-size: 14px;
    line-height: 1.45;
    color: var(--cb-text);
    text-align: left;
    box-sizing: border-box;
}

/* Sötét mód — bot „Mindig sötét” vagy automatikus host-téma; kontrasztos, nem túl fekete */
.cb-widget-root.cb-theme--dark {
    --cb-text: #f1f5f9;
    --cb-text-muted: #94a3b8;
    --cb-text-secondary: #cbd5e1;
    --cb-bg: #1e293b;
    --cb-surface: #0f172a;
    --cb-surface-elevated: #334155;
    --cb-border: #475569;
    --cb-border-input: #64748b;
    --cb-code-bg: #0f172a;
    --cb-blockquote-border: #64748b;
    --cb-shadow-bubble: rgba(0, 0, 0, 0.5);
    --cb-shadow-panel: rgba(0, 0, 0, 0.6);
    --cb-error: #fca5a5;
    --cb-bubble-avatar-bg: #334155;
    --cb-feedback-bg: #1e293b;
    --cb-feedback-hover-bg: #475569;
    --cb-feedback-active-mix: #334155;
    color-scheme: dark;
}

.cb-widget-root [x-cloak] {
    display: none !important;
}

.cb-widget-root *,
.cb-widget-root *::before,
.cb-widget-root *::after {
    box-sizing: border-box;
}

.cb-bubble {
    position: fixed;
    bottom: 20px;
    z-index: 2147483646;
    width: 56px;
    height: 56px;
    border: none;
    border-radius: 50%;
    background: var(--cb-primary);
    color: var(--cb-on-primary);
    cursor: pointer;
    box-shadow: 0 4px 20px var(--cb-shadow-bubble);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.15s ease;
}

.cb-bubble:hover {
    transform: scale(1.05);
}

.cb-bubble--avatar {
    background: var(--cb-bubble-avatar-bg);
    padding: 0;
    overflow: hidden;
    color: inherit;
    border: 1px solid var(--cb-border);
}

.cb-bubble__avatar {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    object-position: center;
    display: block;
    background: var(--cb-bubble-avatar-bg);
}

.cb-bubble--left {
    left: 20px;
}

.cb-bubble--right {
    right: 20px;
}

/* Proaktív felkérés — a launcher fölött ül, ezért nem takarja a gombot. */
.cb-teaser {
    position: fixed;
    bottom: 88px;
    z-index: 2147483646;
    max-width: min(280px, calc(100vw - 32px));
    display: flex;
    align-items: flex-start;
    gap: 4px;
    padding: 10px 8px 10px 14px;
    background: var(--cb-bg);
    color: var(--cb-text);
    border: 1px solid var(--cb-border);
    border-radius: var(--cb-radius);
    box-shadow: 0 8px 24px var(--cb-shadow-panel);
    animation: cb-teaser-in 0.2s ease-out;
}

.cb-teaser--left {
    left: 20px;
}

.cb-teaser--right {
    right: 20px;
}

.cb-teaser__text {
    flex: 1;
    padding: 0;
    border: none;
    background: none;
    color: inherit;
    font: inherit;
    font-size: 14px;
    line-height: 1.4;
    text-align: left;
    cursor: pointer;
}

.cb-teaser__text:hover {
    text-decoration: underline;
}

.cb-teaser__close {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: none;
    color: var(--cb-text-muted);
    cursor: pointer;
}

.cb-teaser__close:hover {
    color: var(--cb-text);
}

@keyframes cb-teaser-in {
    from {
        opacity: 0;
        transform: translateY(6px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (prefers-reduced-motion: reduce) {
    .cb-teaser {
        animation: none;
    }
}

.cb-panel {
    position: fixed;
    bottom: 88px;
    width: min(380px, calc(100vw - 32px));
    height: min(520px, calc(100vh - 120px));
    z-index: 2147483647;
    background: var(--cb-bg);
    border-radius: var(--cb-radius);
    box-shadow: 0 12px 40px var(--cb-shadow-panel);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid var(--cb-border);
}

.cb-panel--left {
    left: 20px;
}

.cb-panel--right {
    right: 20px;
}

.cb-panel__header {
    padding: 10px 10px 10px 16px;
    background: var(--cb-primary);
    color: var(--cb-on-primary);
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-shrink: 0;
}

.cb-panel__title {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 15px;
    line-height: 1.3;
}

.cb-panel__header-actions {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
}

.cb-ai-disclosure {
    flex-shrink: 0;
    padding: 8px 16px;
    font-size: 0.75rem;
    line-height: 1.4;
    color: var(--cb-text-muted);
    background: var(--cb-surface-alt, var(--cb-surface));
    border-bottom: 1px solid var(--cb-border);
}

.cb-header-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: inherit;
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.cb-header-btn:hover:not(:disabled) {
    background: var(--cb-header-btn-hover);
}

.cb-header-btn:active:not(:disabled) {
    background: var(--cb-header-btn-hover-active);
}

.cb-header-btn:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.85);
    outline-offset: 1px;
}

.cb-header-btn:disabled {
    opacity: 0.38;
    cursor: not-allowed;
}

.cb-header-btn__icon {
    display: block;
    flex-shrink: 0;
}

.cb-header-btn--new {
    width: auto;
    height: 32px;
    padding: 0 10px;
    gap: 5px;
    margin-right: 2px;
    border-radius: 999px;
    background: var(--cb-header-btn-new-bg);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.01em;
}

.cb-header-btn--new:hover:not(:disabled) {
    background: var(--cb-header-btn-new-hover);
}

.cb-header-btn__label {
    line-height: 1;
}

.cb-messages {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 12px;
    display: flex;
    flex-direction: column;
    background: var(--cb-surface);
    overscroll-behavior: contain;
}

.cb-messages__inner {
    margin-top: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    min-height: min-content;
}

.cb-msg {
    max-width: 85%;
    padding: 10px 12px;
    border-radius: calc(var(--cb-radius) - 4px);
    word-break: break-word;
}

.cb-msg--user {
    align-self: flex-end;
    background: var(--cb-primary);
    color: var(--cb-on-primary);
}

.cb-msg--user .cb-msg__text {
    white-space: pre-wrap;
}

.cb-msg--assistant {
    align-self: flex-start;
    background: var(--cb-surface-elevated);
    border: 1px solid var(--cb-border);
    color: var(--cb-text);
}

.cb-msg--agent {
    border-color: color-mix(in srgb, var(--cb-primary) 35%, var(--cb-border));
}

.cb-msg--lead-form {
    align-self: flex-start;
    max-width: 100%;
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 0;
}

.cb-msg__agent-label {
    font-size: 11px;
    font-weight: 600;
    color: var(--cb-muted, #64748b);
}

.cb-handover-banner {
    margin: 8px 12px;
    padding: 8px 10px;
    border-radius: calc(var(--cb-radius) - 4px);
    background: color-mix(in srgb, var(--cb-primary) 12%, transparent);
    border: 1px solid color-mix(in srgb, var(--cb-primary) 30%, var(--cb-border));
    color: var(--cb-text);
    font-size: 12px;
    line-height: 1.4;
}

.cb-msg--typing {
    opacity: 0.85;
}

.cb-msg__assistant-wrap {
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-width: 100%;
}

.cb-msg__tool-activity {
    font-size: 12px;
    line-height: 1.4;
    color: var(--cb-muted, #64748b);
    padding: 4px 2px 0;
}

.cb-commerce-media {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* Egy termék — webshop-szerű kártya (csak megjelenítés, nincs kosár gomb) */
.cb-product-card {
    overflow: hidden;
    border: 1px solid var(--cb-border);
    border-radius: var(--cb-radius);
    background: var(--cb-surface-elevated);
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.cb-product-card__media {
    display: block;
    background: var(--cb-surface);
    border-bottom: 1px solid var(--cb-border);
}

.cb-product-card__media--link {
    text-decoration: none;
    color: inherit;
}

.cb-product-card__image {
    display: block;
    width: 100%;
    max-height: 160px;
    object-fit: cover;
}

.cb-product-card__placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    color: var(--cb-text-muted);
    background: var(--cb-feedback-bg);
}

.cb-product-card__placeholder svg {
    width: 36px;
    height: 36px;
    opacity: 0.5;
}

.cb-product-card__body {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 10px 12px 12px;
}

.cb-product-card__title {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.35;
    color: var(--cb-text);
}

.cb-product-card__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 10px;
}

.cb-product-card__price {
    font-size: 14px;
    font-weight: 700;
    color: var(--cb-primary);
    letter-spacing: -0.01em;
}

.cb-product-card__stock {
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 999px;
    line-height: 1.4;
}

.cb-product-card__stock--in {
    color: #166534;
    background: #dcfce7;
}

.cb-product-card__stock--out {
    color: #991b1b;
    background: #fee2e2;
}

.cb-widget-root.cb-theme--dark .cb-product-card__stock--in {
    color: #bbf7d0;
    background: rgba(22, 101, 52, 0.35);
}

.cb-widget-root.cb-theme--dark .cb-product-card__stock--out {
    color: #fecaca;
    background: rgba(153, 27, 27, 0.35);
}

.cb-product-card__link {
    font-size: 12px;
    font-weight: 500;
    color: var(--cb-text-secondary);
    text-decoration: none;
}

.cb-product-card__link:hover {
    color: var(--cb-primary);
    text-decoration: underline;
}

/* Keresési találatok — kompakt kártya rács */
.cb-commerce-media__catalog {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
}

.cb-catalog-card {
    overflow: hidden;
    border: 1px solid var(--cb-border);
    border-radius: calc(var(--cb-radius) - 4px);
    background: var(--cb-surface-elevated);
}

.cb-catalog-card__link,
.cb-catalog-card__static {
    display: flex;
    flex-direction: column;
    height: 100%;
    text-decoration: none;
    color: inherit;
}

.cb-catalog-card__media {
    background: var(--cb-surface);
    border-bottom: 1px solid var(--cb-border);
}

.cb-catalog-card__image {
    display: block;
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
}

.cb-catalog-card__placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1;
    color: var(--cb-text-muted);
    background: var(--cb-feedback-bg);
}

.cb-catalog-card__placeholder svg {
    width: 28px;
    height: 28px;
    opacity: 0.5;
}

.cb-catalog-card__body {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 8px;
    flex: 1;
}

.cb-catalog-card__name {
    font-size: 11px;
    line-height: 1.3;
    color: var(--cb-text);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.cb-catalog-card__price {
    font-size: 12px;
    font-weight: 700;
    color: var(--cb-primary);
}

.cb-source {
    margin: 0;
    padding-left: 2px;
    font-size: 11px;
    line-height: 1.35;
    color: var(--cb-text-muted);
}

.cb-feedback {
    display: flex;
    gap: 6px;
    padding-left: 2px;
}

.cb-feedback__btn {
    border: 1px solid var(--cb-border);
    background: var(--cb-feedback-bg);
    border-radius: 8px;
    width: 32px;
    height: 28px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    opacity: 0.85;
    transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.cb-feedback__btn:hover:not(:disabled) {
    background: var(--cb-feedback-hover-bg);
    border-color: var(--cb-primary);
    opacity: 1;
}

.cb-feedback__btn:disabled:not(.cb-feedback__btn--active) {
    cursor: default;
    opacity: 0.45;
}

.cb-feedback__btn--active {
    border-color: var(--cb-primary);
    background: color-mix(in srgb, var(--cb-primary) 12%, var(--cb-feedback-active-mix));
    opacity: 1;
}

.cb-msg__body {
    font-size: 14px;
    line-height: 1.5;
    text-align: left;
    color: var(--cb-text);
}

.cb-msg__body--pending {
    min-height: 1.25em;
    display: flex;
    align-items: center;
}

.cb-typing {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 2px 2px 0;
}

.cb-typing__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--cb-muted, #94a3b8);
    animation: cb-typing-bounce 1.15s ease-in-out infinite;
}

.cb-typing__dot:nth-child(2) {
    animation-delay: 0.18s;
}

.cb-typing__dot:nth-child(3) {
    animation-delay: 0.36s;
}

@keyframes cb-typing-bounce {
    0%,
    60%,
    100% {
        transform: translateY(0);
        opacity: 0.45;
    }
    30% {
        transform: translateY(-5px);
        opacity: 1;
    }
}

.cb-msg__body > :first-child {
    margin-top: 0;
}

.cb-msg__body > :last-child {
    margin-bottom: 0;
}

.cb-msg__body p {
    margin: 0.45em 0;
}

.cb-msg__body h1,
.cb-msg__body h2,
.cb-msg__body h3,
.cb-msg__body h4 {
    font-weight: 700;
    line-height: 1.3;
    margin: 0.65em 0 0.35em;
    color: var(--cb-text);
}

.cb-msg__body h1 {
    font-size: 1.125rem;
}

.cb-msg__body h2 {
    font-size: 1.05rem;
}

.cb-msg__body h3,
.cb-msg__body h4 {
    font-size: 0.98rem;
}

.cb-msg__body strong,
.cb-msg__body b {
    font-weight: 700;
}

.cb-msg__body em,
.cb-msg__body i {
    font-style: italic;
}

.cb-msg__body ul,
.cb-msg__body ol {
    margin: 0.45em 0;
    padding-left: 1.2em;
}

.cb-msg__body li {
    margin: 0.2em 0;
}

.cb-msg__body li > p {
    margin: 0;
}

.cb-msg__body code {
    font-family: ui-monospace, 'Cascadia Code', 'Segoe UI Mono', monospace;
    font-size: 0.88em;
    background: var(--cb-code-bg);
    padding: 0.12em 0.35em;
    border-radius: 4px;
}

.cb-msg__body pre {
    margin: 0.5em 0;
    padding: 8px 10px;
    background: var(--cb-code-bg);
    border-radius: calc(var(--cb-radius) - 6px);
    overflow-x: auto;
    font-size: 0.85em;
    line-height: 1.45;
    border: 1px solid var(--cb-border);
}

.cb-msg__body pre code {
    padding: 0;
    background: transparent;
    border: none;
}

.cb-msg__body a {
    color: var(--cb-primary);
    text-decoration: underline;
    text-underline-offset: 2px;
}

.cb-msg__body blockquote {
    margin: 0.5em 0;
    padding-left: 0.75em;
    border-left: 3px solid var(--cb-blockquote-border);
    color: var(--cb-text-secondary);
}

.cb-msg__body .cb-md-table-wrap {
    margin: 0.65em 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border: 1px solid var(--cb-border);
    border-radius: calc(var(--cb-radius) - 8px);
}

.cb-msg__body table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    line-height: 1.35;
}

.cb-msg__body th,
.cb-msg__body td {
    padding: 6px 8px;
    text-align: left;
    vertical-align: top;
    border-bottom: 1px solid var(--cb-border);
    white-space: nowrap;
}

.cb-msg__body th {
    font-weight: 650;
    color: var(--cb-text-secondary);
    background: color-mix(in srgb, var(--cb-bg-soft, var(--cb-bg)) 88%, var(--cb-text) 12%);
}

.cb-msg__body tr:last-child td {
    border-bottom: none;
}

.cb-panel__footer {
    padding: 10px 12px;
    border-top: 1px solid var(--cb-border);
    background: var(--cb-bg);
    display: flex;
    gap: 8px;
    align-items: flex-end;
}

.cb-mic {
    border: 1px solid var(--cb-border-input);
    border-radius: calc(var(--cb-radius) - 6px);
    background: var(--cb-bg);
    color: var(--cb-text);
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
}

.cb-mic:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.cb-mic--listening {
    background: #dc2626;
    border-color: #dc2626;
    color: #fff;
}

.cb-mic--active:not(.cb-mic--listening):not(.cb-mic--speaking):not(.cb-mic--processing) {
    background: #dc2626;
    border-color: #dc2626;
    color: #fff;
    box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.35);
}

.cb-mic--processing {
    opacity: 0.7;
    background: #b45309;
    border-color: #b45309;
    color: #fff;
}

.cb-mic__spinner {
    animation: cb-mic-spin 0.75s linear infinite;
}

@keyframes cb-mic-spin {
    to {
        transform: rotate(360deg);
    }
}

.cb-mic--speaking {
    background: #2563eb;
    border-color: #2563eb;
    color: #fff;
}

.cb-input {
    flex: 1;
    border: 1px solid var(--cb-border-input);
    border-radius: calc(var(--cb-radius) - 6px);
    padding: 8px 10px;
    font: inherit;
    resize: none;
    min-height: 40px;
    max-height: 100px;
    background: var(--cb-bg);
    color: var(--cb-text);
}

.cb-input::placeholder {
    color: var(--cb-text-muted);
}

.cb-input:focus {
    outline: 2px solid var(--cb-primary);
    outline-offset: 0;
}

.cb-send {
    border: none;
    border-radius: calc(var(--cb-radius) - 6px);
    background: var(--cb-primary);
    color: var(--cb-on-primary);
    width: 40px;
    height: 40px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
}

.cb-send:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.cb-branding {
    text-align: center;
    padding: 4px 8px 8px;
    background: var(--cb-bg);
}

.cb-branding__link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    text-decoration: none;
}

.cb-branding__label {
    font-size: 11px;
    color: var(--cb-text-muted);
    line-height: 1;
}

.cb-branding__logo {
    display: block;
    height: 22px;
    width: auto;
    max-width: 100%;
}

.cb-error {
    padding: 12px;
    color: var(--cb-error);
    font-size: 13px;
    text-align: center;
    background: var(--cb-bg);
}

.cb-lead-form {
    margin: 8px 0;
    padding: 14px;
    border: 1px solid var(--cb-border);
    border-radius: var(--cb-radius);
    background: var(--cb-bg);
    max-width: 100%;
}

.cb-lead-form__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 12px;
}

.cb-lead-form__title {
    font-size: 15px;
    font-weight: 600;
    margin: 0;
    color: var(--cb-text);
}

.cb-lead-form__close {
    background: none;
    border: none;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    color: var(--cb-text-muted);
    padding: 0 4px;
}

.cb-lead-form__body {
    display: block;
}

.cb-lead-form__hint {
    font-size: 12px;
    line-height: 1.4;
    color: var(--cb-text-muted);
    margin: 0 0 10px;
}

.cb-lead-form__field {
    display: block;
    margin-bottom: 10px;
}

.cb-lead-form__label {
    display: block;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 4px;
    color: var(--cb-text);
}

.cb-lead-form__input {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 10px;
    border: 1px solid var(--cb-border);
    border-radius: 8px;
    font-size: 14px;
    background: var(--cb-input-bg);
    color: var(--cb-text);
}

.cb-lead-form__consent {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    font-size: 12px;
    color: var(--cb-text-muted);
    margin: 12px 0;
}

.cb-lead-form__consent a {
    color: var(--cb-primary);
}

.cb-lead-form__submit {
    width: 100%;
    padding: 10px 14px;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-weight: 600;
    cursor: pointer;
}

.cb-lead-form__submit:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.cb-lead-form__error {
    color: var(--cb-error);
    font-size: 13px;
    margin: 8px 0;
}

.cb-lead-form__success {
    font-size: 14px;
    color: var(--cb-text);
    margin: 0;
}
